/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types'

// import withStyles from 'isomorphic-style-loader/lib/withStyles';
// import s from './NotFoundPage.scss';

const title = 'Page not found';

class NotFound extends Component {

  // static contextTypes = {
  //   onSetTitle: PropTypes.func.isRequired,
  //   onPageNotFound: PropTypes.func.isRequired,
  // };

  componentWillMount() {
    // this.context.onSetTitle(title);
    // this.context.onPageNotFound();
  }

  render() {
    return (
      <div style={{padding: 20}}>
        <h1>{title}</h1>
        <p>
          Sorry, the page you were trying to view does not exist.
          <br /><br />
          Please try again in a moment.
        </p>
      </div>
    );
  }

}

export default NotFound
// export default withStyles(NotFound, s);



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js